import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatPaginator, MatSelectChange, MatSort, MatTableDataSource } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { merge } from 'rxjs/observable/merge';
import { of as observableOf } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { startWith } from 'rxjs/operators/startWith';
import { switchMap } from 'rxjs/operators/switchMap';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { LinkDeviceDialogComponent } from '../link-device-dialog/link-device-dialog.component';
import { DelinkDeviceDialogComponent } from '../delink-device-dialog/delink-device-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LicenseService } from '../license.service';
import 'rxjs/add/observable/combineLatest';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AccountService } from '../account.service';
import { debounceTime } from 'rxjs/operators';
import { LicenseTypes } from '../models/license';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-license-list',
  templateUrl: './license-list.component.html',
  styleUrls: ['./license-list.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class LicenseListComponent implements OnInit {
  displayedColumns = ['id', 'account', 'type', 'package', 'device', 'active', 'balance', 'expires', 'sub', 'additional'];
  dataSource = new MatTableDataSource();

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  licenseTypes: LicenseTypes[] = [
    LicenseTypes.SELFTESTBUNDLE,
    LicenseTypes.HEARSPEECHSTANDARD,
    LicenseTypes.HEARTESTSTANDARD,
    LicenseTypes.HEARTEST_OCCHEALTH_STANDARD,
    LicenseTypes.HEARSCREENSTANDARD,
    LicenseTypes.PEEKACUITYSTANDARD,
    LicenseTypes.VISIONSTANDARD,
    LicenseTypes.SEALCHECKSTANDARD,
    LicenseTypes.SEALCHECKSTANDARD_VARIPHONE,
    LicenseTypes.HEARKIOSKDIN,
    LicenseTypes.HEARKIOSKPTA,
  ];

  activeStates = [
    { id: 0, label: 'any' },
    { id: 1, label: 'only active' },
    { id: 2, label: 'only inactive' },
  ];
  selectedActiveState = this.activeStates[0];

  expiresOpts = [
    { id: 0, label: 'all' },
    { id: 1, label: 'in 1 month' },
    { id: 2, label: 'in 2 months' },
    { id: 3, label: 'never' },
    { id: 4, label: 'already expired' },
    { id: 5, label: 'not expired' },
  ];
  selectedExpiresOpt = this.expiresOpts[0];

  searchFilterFields = ['account', 'device_id', 'type'];
  filter: any = {
    type: '',
    value: ''
  };
  filter$ = new Subject;
  refresh$ = new Subject;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  expandedElement: any;

  constructor(private http: HttpClient,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private licenseService: LicenseService,
    private _accountService: AccountService) { }

  ngOnInit() {

    // If the user changes the sort order, reset back to the first page.
    this.dataSource.paginator = this.paginator;


    let adsf = merge(this.refresh$)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.licenseService.getLicenses();
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.resultsLength = data.length;

          return data;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          return observableOf([]);
        })
      );
    Observable.combineLatest(adsf, this.filter$)
    .pipe(debounceTime(500))
    .subscribe(([data, filter]) => {

      data.forEach((el: any) => {
        if (Number(el.account_id) && Number(el.account_id) > 0 ) {
          // console.log('account', el.account_id);

          this._accountService.byId(Number(el.account_id)).subscribe((acc) => {
            // console.log("account", acc)
            if (acc) {
              el.account = acc;
              el.account_email = acc.email;
            }
          });
        }
        if (el.device_id && el.device_id !== -1) {
          this._accountService.deviceById(Number(el.device_id)).subscribe((d) => {
            if (d) {
              el.device = d;
              el.device_imei = d.imei;
              el.device_model = d.model;
            }
          });
        }
      });

      if (filter['type'] && filter['type'] !== 'multi' && filter['value']) {
        // console.log(filter['type'])
        // console.log(filter['value'])
        this.dataSource.data = data.filter((a) => {
          // HACK(austin): search the JSON string to search all fields at once
          const v = JSON.stringify(a[filter['type']] || '').toLowerCase();
          const s = filter['value'].toString().toLowerCase();
          return v.includes(s);
        });
      } else if (filter['type'] === 'multi') {
        let fdata = data;
        console.log(filter);
        if (typeof filter['account'] === 'string' && filter['account'].length > 0) {
          console.log('filter by account');
          fdata = fdata.filter((a) => {
            const v = JSON.stringify(a['account'] || '').toLowerCase();
            const s = filter['account'].toString().toLowerCase();
            return v.includes(s);
          });
        }

        // // hide discovery licenses
        // fdata = fdata.filter(a => {
        //   const v = JSON.stringify(a['account'] || '').toLowerCase();
        //   const s = 'disc_integrations';
        //   return !v.includes(s);
        // });

        if (typeof filter['deviceID'] === 'string' && filter['deviceID'].length > 0) {
          console.log('filter by device', typeof filter['deviceID']);
          fdata = fdata.filter((a) => {
            const v = a['device_id'];
            const s = filter['deviceID'].toString().toLowerCase();
            return v === s;
          });
        }
        if (typeof filter['licenseType'] === 'string' && filter['licenseType'].length > 0) {
          console.log('filter by license type', typeof filter['licenseType']);
          fdata = fdata.filter((a) => {
            const v = (a['type'] || '').toLowerCase();
            const s = filter['licenseType'].toString().toLowerCase();
            return v.includes(s);
          });
        }
        if (typeof filter['activeState'] === 'object') {
          console.log('filter by active state');
          let pred: (active: boolean) => boolean;
          switch (filter['activeState'].id) {
            case 1: pred = (active) => active; break;
            case 2: pred = (active) => !active; break;
            default: pred = () => true; break;
          }
          fdata = fdata.filter((el) => pred(el['active']));
        }
        if (typeof filter['expiresOpt'] === 'object') {
          console.log('filter by expires', filter['expiresOpt']);
          const now = new Date();
          let pred: (expires?: Date) => boolean;
          switch (filter['expiresOpt'].id) {
            case 1: pred = (expires) => (!!expires
              && expires.getTime() > now.getTime()
              && expires.getTime() < (now.getTime() + 30 * 24 * 60 * 60 * 1000)); break;
            case 2: pred = (expires) => (!!expires
              && expires.getTime() > now.getTime()
              && expires.getTime() < (now.getTime() + 60 * 24 * 60 * 60 * 1000)); break;
            case 3: pred = (expires) => !expires; break;
            case 4: pred = (expires) => (!!expires && expires.getTime() < now.getTime()); break;
            case 5: pred = (expires) => (!expires || expires.getTime() > now.getTime()); break;
            default: pred = () => true; break;
          }
          fdata = fdata.filter((el) => {
            let exp: Date | null = null;
            try {
              if (el.expires) {
                exp = new Date(el.expires);
              }
            } catch (err) {
              console.error('could not parse date', el.expires, err);
            }
            return pred(exp);
          });
        }
        this.dataSource.data = fdata;
      } else {
        this.dataSource.data = data;
      }
    });
    this.filter$.next({});
    this.refresh$.next({});
  }

  refresh() {
    this.refresh$.next(true);
  }

  searchChange(search: any, column: any) {

    this.filter$.next({
      type: column,
      value: search
    });
  }

  searchChange2(account: any, deviceID: any, licenseType: any) {
    this.filter$.next({
      type: 'multi',
      account,
      deviceID,
      licenseType,
      activeState: this.selectedActiveState,
      expiresOpt: this.selectedExpiresOpt,
    });
  }

  activeSelEvent(ev: MatSelectChange) {
    console.log('activeSelEvent', ev.value);
  }

  openAttachDevice(license_id: number, accID: number): void {
    let dialogRef = this.dialog.open(LinkDeviceDialogComponent, {
      width: '250px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      if (result) {
        this.licenseService.LinkLicenseToDevice(license_id, result, accID).subscribe(
          (data) => {
            this.snackBar.open('Success', '', {
              duration: 1250,
              verticalPosition: 'top',
              horizontalPosition: 'end'
            });
            this.refresh();
          },
          (error) => {
            this.snackBar.open('Something went wrong', '', {
              duration: 1250,
              verticalPosition: 'top',
              horizontalPosition: 'end'
            });
          }
        );
      }
    });
  }

  qrCodeData(row: any) {
    let type = '';
    if (!row.track_credits) {
      type = `unlimited`;
    } else {
      type = `${row.credits} credits/ ${row.frequency}`;
    }
    return { type: row.type, description: type, license_id: row.id };
  }

  openDelinkDevice(license_id: number): void {
    let dialogRef = this.dialog.open(DelinkDeviceDialogComponent, {
      width: '250px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      if (result) {
        this.licenseService.DelinkDeviceFromLicense(license_id).subscribe(
          (data) => {
            console.log(data);
            this.snackBar.open('Success', '', {
              duration: 1250,
              verticalPosition: 'top',
              horizontalPosition: 'end'
            });
            this.refresh();
          },
          (error) => {
            this.snackBar.open('Something went wrong', '', {
              duration: 1250,
              verticalPosition: 'top',
              horizontalPosition: 'end'
            });
          }
        );
      }
    });
  }

  checkInactive(row: any): boolean {
    // console.log('checkActive', row);
    try {
      if (!row.active) {
        return true;
      }
      if (!row.expires) { // no expiry
        return false;
      }
      const exp = new Date(row.expires);
      const now = new Date();
      if (exp.getTime() < now.getTime()) { // expiry date has passed
        return true;
      }
      return false;
    } catch (e) {
      console.error('could not check active', e);
      return false;
    }
  }

  checkExpiring(row: any): boolean {
    // console.log('checkExpiring', row);
    try {
      if (!row.expires) { // no expiry
        return false;
      }
      const exp = new Date(row.expires);
      const now = new Date();
      // console.log(exp.getTime(), now.getTime() + 60 * 24 * 60 * 60 * 1000);
      if (exp.getTime() < (now.getTime() + 60 * 24 * 60 * 60 * 1000)) { // expiry date has passed
        return true;
      }
      return false;
    } catch (e) {
      console.error('could not check active', e);
      return false;
    }
  }

  toggleActive(row: any) {
    console.log('toggle active', row);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { heading: row.active ? 'Disable license?' : 'Enable license?' },
    });
    dialogRef.afterClosed().subscribe((rsp) => {
      if (rsp !== 'yes') {
        return;
      }
      this.licenseService.patchActive(row.id, row.account_id, !row.active).subscribe(
        () => {
          this.snackBar.open(row.active ? 'disabled license' : 'enabled license', 'OK');
          this.refresh();
        },
        (err) => {
          this.snackBar.open('something went wrong' + err, 'OK');
        }
      );
    });
  }

  // updateExpires(row: any, newExpires?: string) {
  //   console.log('toggle active', row);

  //   let expires: Date | null = null;
  //   try {
  //     if (newExpires) {
  //       expires = new Date(newExpires);
  //     }
  //   } catch (err) {
  //     console.error('could not parse date', err);
  //   }

  //   this.licenseService.patchExpires(row.id, row.account_id, expires).subscribe(
  //     () => {
  //       this.snackBar.open('updated expires date', 'OK');
  //       this.refresh();
  //     },
  //     (err) => {
  //       this.snackBar.open('something went wrong' + err, 'OK');
  //     }
  //   );
  // }

}



// WEBPACK FOOTER //
// ./src/app/license-list/license-list.component.ts